export function downloadFile(fileName: string, file: string) {
  const el = document.createElement("a");
  el.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(file));
  el.setAttribute("download", fileName);
  el.style.display = "none";
  document.body.append(el);
  el.click();
  document.body.removeChild(el);
}
